import { useMutation, useQueryClient } from '@tanstack/react-query';

import { getUrlToBackendApi, request } from '@shared/services/api';

import { GET_ME_QUERY_KEY } from '@hooks/api/user/use-query-me';

const REQUEST_URL = '/login_by_ott';
const MUTATION_KEY = ['auth', 'ott'];

type LoginResponse = {
	status: string;
	meta: {
		access_token: string;
		refresh_token: string;
	};
};

export const useMutationOttAuthorization = () => {
	const queryClient = useQueryClient();
	const urlParams = new URLSearchParams(window.location.search);
	const ott = urlParams.get('ott');

	return useMutation({
		mutationKey: MUTATION_KEY,
		mutationFn: async () => {
			if (!ott) {
				return;
			}

			const response = await request<LoginResponse>({
				method: 'post',
				url: getUrlToBackendApi(REQUEST_URL).href,
				data: { ott }
			});

			if (response.status === 'success' && response?.meta?.access_token) {
				localStorage.setItem('auth_token', response.meta.access_token);
			}

			return response;
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: GET_ME_QUERY_KEY });
		},
		onError: error => {
			console.error('Error during login mutation:', error);
		}
	});
};
